import api from './api';
import { todayString } from './appDateTime';
import { downloadBlob, getApiErrorMessage, parseBlobError } from './blobDownload';

export async function fetchTicketAttachmentBlob(attachmentId) {
  const res = await api.get(`/crm/tickets/attachments/${attachmentId}/download`, { responseType: 'blob' });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  if (!(res.data instanceof Blob) || res.data.size === 0) {
    throw new Error('Attachment file is empty or unavailable');
  }
  return res.data;
}

export async function fetchTicketAttachmentPreviewBlob(attachmentId) {
  const res = await api.get(`/crm/tickets/attachments/${attachmentId}/preview`, { responseType: 'blob' });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  if (!(res.data instanceof Blob) || res.data.size === 0) {
    throw new Error('Attachment file is empty or unavailable');
  }
  return res.data;
}

export async function downloadTicketAttachment(attachmentId, filename) {
  const blob = await fetchTicketAttachmentBlob(attachmentId);
  await downloadBlob(blob, filename || 'attachment');
}

export async function exportTicketCsv(params = {}) {
  const res = await api.get('/crm/tickets/export', { params, responseType: 'blob' });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  const date = todayString();
  await downloadBlob(res.data, `crm-tickets-${date}.csv`);
}

export async function exportTicketReportCsv(reportType) {
  const res = await api.get(`/crm/tickets/reports/${reportType}`, {
    params: { format: 'csv' },
    responseType: 'blob',
  });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  const date = todayString();
  await downloadBlob(res.data, `ticket-report-${reportType}-${date}.csv`);
}

export { getApiErrorMessage };
